import classNames from 'classnames';
import { ReactComponent as RepeatIcon } from '@Icons/additional/repeat.svg';

import styles from './material-tab-item.module.css';

interface MaterialTabItemProps {
  index: number;
  activityCode: string | number;
  activityName: string | undefined;
  resourceCode: string | number;
  resourceDescription: string | undefined;
  materialCode: string | number;
  materialDescription: string | undefined;
  plantCode: string | number;
  plantId: number | null;
  plantName: string | undefined;
  ledgerName: string | undefined;
  ledgerCode: string | number;
  ledgerId: number | null;
  unit: string | number;
  qty: string | number;
  remarks: string;
  repeatItem: boolean;
}

const MaterialTabItem: React.FC<MaterialTabItemProps> = ({
  activityCode,
  activityName,
  materialCode,
  materialDescription,
  resourceDescription,
  ledgerCode,
  ledgerName,
  plantCode,
  plantName,
  qty,
  remarks,
  resourceCode,
  unit,
  index,
  repeatItem = false,
}) => {
  return (
    <div className={classNames(styles.container, repeatItem && styles.active)}>
      <div className={styles.header}>
        <div className={styles.caption}>Material No.{index}</div>
        {repeatItem && (
          <div className={styles.actions}>
            <div className={styles.state}>Template</div>
          </div>
        )}
      </div>
      <div className={styles.content}>
        {Boolean(activityCode) && (
          <div className={styles.description}>
            <span>{activityName ? 'Activity' : 'Activity Code'}</span>
            <div>
              {repeatItem && (
                <span className={styles.repeatIcon}>
                  <RepeatIcon />
                </span>
              )}
              <span>{activityName || activityCode}</span>
            </div>
          </div>
        )}
        {Boolean(resourceCode) && (
          <div className={styles.description}>
            <span>{resourceDescription ? 'Resource' : 'Resource Code'}</span>
            <span>{resourceDescription || resourceCode}</span>
          </div>
        )}
        {Boolean(materialCode) && (
          <div className={styles.description}>
            <span>{materialDescription ? 'Material' : 'Material Code'}</span>
            <span>
              {materialDescription
                ? `${materialDescription} (${materialCode})`
                : materialCode}
            </span>
          </div>
        )}
        {Boolean(plantCode) && (
          <div className={styles.description}>
            <span>{plantName ? 'Plant' : 'Plant Code'}</span>
            <span>{plantName ? `${plantName} (${plantCode})` : plantCode}</span>
          </div>
        )}
        {Boolean(ledgerCode) && (
          <div className={styles.description}>
            <span>{ledgerName ? 'Ledger' : 'Ledger Code'}</span>
            <span>
              {ledgerName ? `${ledgerName} (${ledgerCode})` : ledgerCode}
            </span>
          </div>
        )}
        <div className={styles.description}>
          <span>Unit</span>
          <span>{unit}</span>
        </div>
        <div className={styles.description}>
          <span>Qty.</span>
          <span>{qty}</span>
        </div>
        <div className={styles.description}>
          <span>Remarks</span>
          <span>{remarks}</span>
        </div>
      </div>
    </div>
  );
};

export default MaterialTabItem;
